import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import reloadTableOnTriageActionFail from 'owa-mail-actions/lib/table-loading/reloadTableOnTriageActionFail';
import undoWhenNotificationChannelNotReady from 'owa-mail-actions/lib/table-loading/undoWhenNotificationChannelNotReady';

export { getCanTableLoadMore } from './utils/getCanTableLoadMore';
export { getCanTableLoadMorePrevious } from './utils/getCanTableLoadMorePrevious';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "TableLoadMore" */ './lazyIndex'),
    { name: 'TableLoadMore' }
);

registerLazyOrchestrator(
    reloadTableOnTriageActionFail,
    lazyModule,
    m => m.reloadTableOnTriageActionFailOrchestrator
);

registerLazyOrchestrator(
    undoWhenNotificationChannelNotReady,
    lazyModule,
    m => m.reloadTableUponUndoWithoutNotificaitonChannel
);

export const lazyLoadMoreInTable: LazyAction<typeof lazyIndex.loadMoreInTable, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.loadMoreInTable);
export const lazyReloadInboxPostBoot: LazyAction<
    typeof lazyIndex.reloadInboxPostBoot,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.reloadInboxPostBoot);
export const lazyReloadTable: LazyAction<typeof lazyIndex.reloadTable, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.reloadTable);

export { tryLoadMoreUponRowRemove } from './actions/tryLoadMoreUponRowRemove';
import './orchestrators/loadMoreInTableOrchestrator';
